import { Menu as RAMenu } from 'react-admin'

/**
 * Explicit sidebar ordering: historical inspections first, live inspections
 * second.
 *
 * Keep this in step with the <Resource> order in App.tsx. The two are read by
 * different things — this list drives the sidebar, while React Admin sends `/`
 * to the first *registered* resource the user can list — so letting them drift
 * would put the landing screen and the top menu item out of sync.
 */
export const Menu = () => (
  <RAMenu>
    <RAMenu.ResourceItem name="historical_inspections" />
    <RAMenu.ResourceItem name="inspections" />
  </RAMenu>
)
